// extracted by mini-css-extract-plugin
export default {"taskList":"tasklist_taskList__dkWxc","mSpinner":"tasklist_mSpinner__rj9hs","cardCstm":"tasklist_cardCstm__teSJ7","opened":"tasklist_opened__+gBe-","active":"tasklist_active__eSrQ2"};